import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from 'app/core/auth/permissions/permission.service';
import { filter, map, take } from 'rxjs';

export const PermissionGuard: CanActivateFn = (route, state) => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const requiredPermission = route.data['permission'] as string;

  if (!requiredPermission) {
    return true; // No permission required
  }

  // Wait for permissions to be loaded before checking.
  // We rely on permissionsLoaded$ to emit true (on success or error) so this doesn't hang.
  return permissionService.permissionsLoaded$.pipe(
    filter(loaded => loaded),
    take(1),
    map(() => {
      if (permissionService.hasPermission(requiredPermission)) {
        return true;
      }
      router.navigate(['/permission-denied']);
      return false;
    })
  );
};
